import React, { useEffect, useState } from 'react';
import UserMasterHeader from './UserCommonComponent/UserMasterHeader';
import { Button, Col, Container, Row } from 'react-bootstrap';
import afterlogo from '../assets/login-after.png';
import QRlogo from '../assets/QRCode.jpeg';
import UserMasterFooter from './UserCommonComponent/UserMasterFooter';
import axios from 'axios';
import { PaymentAdd, RegistrationSelect } from '../AllApi/UserApi/UserApi';
import { toast } from 'react-toastify';
import { Form } from 'react-bootstrap';
import { BrowserRouter as Router, useNavigate } from 'react-router-dom';
import { Modal } from 'antd';
import HeaderPage from '../NewLoginPage/HeaderPage';


const PaymentNewOnline = () => {

  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate()
  const data = JSON.parse(sessionStorage.getItem("status"))
  const [Image, setImage] = useState(null);
  const userdata = JSON.parse(sessionStorage.getItem("userdata"));
  const userid = userdata.id
  const regid = userdata.reg_id
  const member_id = userdata.id
  const [transactionId, setTransactionId] = useState()
  const [amount, setAmount] = useState(1200);
  const [Userdata, setUserdata] = useState({});
  const currentDate = new Date();

  const logoutFun = () => {
    sessionStorage.removeItem("userdata");
    sessionStorage.clear()
    navigate("/");    
  }

  // const [isUpdate, setIsUpdate] = useState(false);

  const validateFileSize = (file, maxSizeMB, errorMessage) => {
    if (file) {
      const fileSizeInMB = file.size / (1024 * 1024); // Convert to MB
      if (fileSizeInMB > maxSizeMB) {
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        return false;
      }
    }
    return true;
  };


  const [open, setOpen] = useState(false);

  const hideModal = () => {
    setOpen(false);
    logoutFun(); 
  };


  const NewData = (e) => {
    e.preventDefault();
  };


// select api=====================
  const getUserData = () => {

    axios.get(`${RegistrationSelect}${member_id}`)
      .then((res) => {
        const user = res.data[0];
        setIsLoading(false);
        if (user !== null) {
          setUserdata(user.data);

        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  useEffect(() => {
    getUserData()
  }, [])


  const setImgfun = (e) => {
    // setupdateimage(false)
    setImage(e.target.files[0])
  }

//============QR img download====================
const downloadQRCode = () => {
  const link = document.createElement('a');
  link.href = QRlogo;
  link.download = <img src={QRlogo} className='w-80 text-center px-md-3 px-1 mb-3 mb-md-0' height={250} />;
  link.click();
};
//==========================================
  return (
    <div className='p-0'>
      
      <HeaderPage />    

      <Container className='p-0 my-5'>

      <div className="row m-0 p-0">

        <div className="col-12 col-md-2"></div>

        <div className='col-12 col-md-8 rounded shadow p-2 p-lg-5' style={{backgroundColor:"#fcc6b5"}} >

          <Row className='m-0'>
            <Col>
              <div className='mt-3 mt-md-0' style={{ display: "flex", justifyContent: "center", color: "rgb(134, 28, 18)" }}>
                <h5><b >Pay Your Registration Fee.</b></h5>
              </div>
            </Col>
          </Row>

          <Row className=''>
          
            <Col sm={12}>

              <div className='row m-0 p-0 py-2'>
                    <div className='col-12 col-md-4'>
                        <b>Account Name :</b>
                    </div>
                    <div className='col-12 col-md-8'>
                        <span style={{fontSize:"20px"}}>MANIKBAG DIGAMBAR JAIN BOARDING</span>
                    </div>
              </div>

              <div className='row m-0 p-0 py-2'>
                    <div className='col-12 col-md-4'>
                        <b>Account No :</b>
                    </div>
                    <div className='col-12 col-md-8'>
                        <span style={{fontSize:"20px"}}>05292010000710</span>
                    </div>
              </div>

              {/* <div className='row m-0 p-0 py-2'>
                    <div className='col-12 col-md-4'>
                        <b>UPI ID :</b>
                    </div>
                    <div className='col-12 col-md-8'>
                        <span style={{fontSize:"20px"}}>getepay.svccblqr432819@icici</span>
                    </div>
              </div> */}

              <div className='row m-0 p-0 py-2'>
                    <div className='col-12 col-md-4'>
                        <b>Bank Name/Branch :</b>
                    </div>
                    <div className='col-12 col-md-8'>
                        <span style={{fontSize:"20px"}}>Canara Bank / ( MAHADWAR ROAD BELAGAVI )</span>
                    </div>
              </div>

              <div className='row m-0 p-0 py-2'>
                    <div className='col-12 col-md-4'>
                        <b>IFSC Code :</b>
                    </div>
                    <div className='col-12 col-md-8'>
                        <span style={{fontSize:"20px"}}>CNRB0002537</span>
                    </div>
              </div>


            </Col>
            <Col sm={12} className='d-flex justify-content-center text-center'>
                <Button
                  onClick={NewData}
                  style={{
                    display: "flex",
                    backgroundColor: "orangered",
                    border: "none",
                    justifyContent: "center",
                  }}
                  className="my-4 py-2 px-4"
                >
                  <b>{isLoading ?  "Submitting..." : "Submit"}</b>
                </Button>
            </Col>
          </Row>

        </div>

        <div className="col-12 col-md-2"></div>
        </div>
      </Container>

     <UserMasterFooter />

    </div>
  )
}

export default PaymentNewOnline
